import { Instagram, Facebook, Youtube, MessageCircle } from "lucide-react";
import { LogoFull } from "./Logo";
import { NAV_LINKS } from "@/data/content";
import { scrollToSection } from "@/App";
import { waLink, GENERAL_MESSAGE } from "@/config";

const SOCIALS = [
  { icon: Instagram, label: "Instagram", href: "https://www.instagram.com/health.coach.anjali" },
  { icon: Facebook, label: "Facebook", href: "https://www.facebook.com/profile.php?id=61564508802979" },
  { icon: Youtube, label: "YouTube", href: "https://youtube.com/@WellnesswithAnjali" },
  { icon: MessageCircle, label: "WhatsApp", href: "https://wa.me/919896978413" },
];

export default function Footer() {
  return (
    <footer className="bg-forest text-ivory pt-20 pb-10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-12 pb-14 border-b border-ivory/10">
          <div>
            <LogoFull dark />
            <p className="mt-5 text-sm text-ivory/70 leading-relaxed">
              Founded by Dr. Anjali
              <br />
              PhD | Certified Health Coach | Certified Nutrigenomics Consultant | Meditation Trainer
            </p>
            <p className="mt-5 font-serif italic text-lg text-gold leading-snug">
              "On a Mission to Transform 1,000 Lives Till 2027"
            </p>
            <p className="mt-3 text-sm text-ivory/60 leading-relaxed">
              Building healthier individuals, stronger families and a healthier Bharat — one sustainable health
              transformation at a time.
            </p>
          </div>
          <nav aria-label="Footer">
            <p className="text-xs uppercase tracking-[0.25em] font-bold text-gold mb-5">Explore</p>
            <ul className="grid grid-cols-2 gap-x-6 gap-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    onClick={() => scrollToSection(l.id)}
                    data-testid={`footer-link-${l.id}`}
                    className="text-sm text-ivory/75 hover:text-gold transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
              <li>
                <a
                  href={waLink(GENERAL_MESSAGE)}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-link-contact"
                  className="text-sm text-ivory/75 hover:text-gold transition-colors"
                >
                  Contact
                </a>
              </li>
            </ul>
            <div className="flex gap-3 mt-8">
              {SOCIALS.map((s) => {
                const Icon = s.icon;
                return (
                  <a
                    key={s.label}
                    href={s.href}
                    target={s.href === "#" ? undefined : "_blank"}
                    rel="noopener noreferrer"
                    aria-label={`Aarogyam Bharat on ${s.label}`}
                    data-testid={`footer-social-${s.label.toLowerCase()}`}
                    className="w-10 h-10 rounded-full bg-ivory/10 border border-ivory/15 flex items-center justify-center hover:bg-gold hover:text-forest hover:border-gold transition-colors"
                  >
                    <Icon size={17} />
                  </a>
                );
              })}
            </div>
          </nav>
          <div>
            <p className="text-xs uppercase tracking-[0.25em] font-bold text-gold mb-5">Five Pathways</p>
            <ul className="space-y-2.5 text-sm text-ivory/75">
              <li>M.O.T.H.E.R. Fit™ — Weight Management for Busy Mothers</li>
              <li>T.H.Y.R.O.I.D. Balance™ — Thyroid Wellness & Metabolic Support</li>
              <li>P.C.O.S. Harmony™ — PCOS Metabolic & Hormonal Wellness</li>
              <li>S.U.G.A.R. Reset™ — Blood Sugar & Metabolic Health</li>
              <li>S.L.I.M. RESET™ — Sustainable Weight Management & Metabolic Wellness</li>
              <li>TATVA Balance™ — Personalised Meditation for Mind–Body Balance</li>
            </ul>
          </div>
        </div>
        <p className="pt-10 text-xs leading-relaxed text-ivory/50 max-w-4xl" data-testid="footer-disclaimer">
          Information provided by Aarogyam Bharat is for educational and wellness purposes and is not intended to
          diagnose, treat, cure or prevent any disease. Health coaching does not replace medical care, diagnosis
          or treatment. Individuals with medical conditions should continue working with their qualified
          healthcare professionals.
        </p>
        <p className="mt-6 text-xs text-ivory/50">© 2026 Aarogyam Bharat. All Rights Reserved.</p>
      </div>
    </footer>
  );
}
